import { BUSINESS_LEGAL_NAME } from '../legal/BUSINESS_LEGAL_NAME';
import { PROJECT_NAME } from './PROJECT_NAME';
/**
 * @group Project
 * @summary Project copyright
 * 
 * @remarks
 * This constant contains the project copyright notice used in footers,
 * legal pages, and other areas requiring copyright information.
 * 
 * @example
 * ```typescript
 * import { PROJECT_COPYRIGHT } from '@shared/constants';
 * 
 * const footer = document.querySelector('footer');
 * if (footer) {
 *   footer.innerHTML = `<p>${PROJECT_COPYRIGHT}</p>`;
 * }
 * ```
 */
export const PROJECT_COPYRIGHT = `${BUSINESS_LEGAL_NAME} Trading as ${PROJECT_NAME} All rights reserved.`; 